//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface AddConversationAttachment {
    filename: string;
}

export interface Address {
    line1: string;
    line2: string | null;
    line3: string | null;
    line4: string | null;
    locality: string | null;
    region: string | null;
    postcode: string;
    country: string | null;
    latitude: string | null;
    longitude: string | null;
    source: string | null;
}

export interface Branch {
    dateCreated: string;
    id: string;
    recordVersion: string;
    franchiseeId: string;
    taxRegistrationNumber: string | null;
    abbreviation: string;
    name: string;
    physicalAddress: Address;
    billingAddress: Address | null;
    physicalAddressAsDefaultShipping: boolean;
    shippingNotes: string | null;
}

export interface BranchInboxAttachment {
    displayName: string;
    virtualPath: string;
}

export interface BranchInboxAttachments {
    items: BranchInboxAttachment[];
}

export interface BranchInboxItem {
    dateCreated: string;
    id: string;
    recordVersion: string;
    subject: string;
    branchId: string;
    message: string;
    attachments: BranchInboxAttachments;
    navigation: BranchInboxNavigation;
}

export enum BranchInboxItemState {
    Unread = 0,
    Pinned = 1,
    Read = 2,
    Hidden = 4,
}

export interface BranchInboxNavigation {
    items: UINavigation[];
}

export interface BranchQuote {
    dateCreated: string;
    id: string;
    recordVersion: string;
    branchId: string;
    globalSupplierSupplierId: string;
    quoteSetId: string;
    clientId: string;
    clientName: string | null;
    contactId: string;
    contactName: string | null;
    clientTypeId: string;
    clientTypeName: string | null;
}

export interface BranchQuoteSupport {
    dateCreated: string;
    id: string;
    recordVersion: string;
    subject: string;
    branchQuoteId: string;
    conversationId: string;
    status: BranchQuoteSupportStatus;
    type: BranchQuoteSupportItemType;
    lastModified: string;
    lastModifiedUserId: string;
    createdUserId: string;
    masterDocumentConversationId: string | null;
}

export enum BranchQuoteSupportItemType {
    All = 0,
    Basic = 1,
    QuoteReview = 2,
    EngineeredToOrder = 4,
    QuoteAssistanceRequest = 8,
}

export enum BranchQuoteSupportStatus {
    All = 0,
    New = 1,
    Overdue = 2,
    Active = 4,
    Resolved = 8,
    Cancelled = 16,
    ReActivated = 32,
    Draft = 64,
}

export interface BuyInStockItem {
    supplierId: string;
    code: string;
    description: string;
    resourceType: number;
    libCode: string;
    supplierCode: string;
}

export interface CSVProducerData {
    fileName: string;
    columns: string[];
    rows: { [key: string]: any; }[];
}

export interface ConnectedState {
    connected: boolean;
}

export interface ConnectedStateServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ConnectedState | null;
}

export enum CurrencyTypeOption {
    NZD = 1,
    AUD = 2,
    USD = 3,
}

export interface Franchisee {
    dateCreated: string;
    id: string;
    recordVersion: string;
    tenantId: number;
    taxRegistrationNumber: string | null;
    name: string;
    positiveLogoVirtualPath: string | null;
    negativeLogoVirtualPath: string | null;
    properties: { [key: string]: string; };
}

export interface FranchiseeClient {
    dateCreated: string;
    id: string;
    recordVersion: string;
    paymentProfileId: string | null;
    externalCustomerReference: string | null;
}

export interface FranchiseeConfiguration {
    dateCreated: string;
    id: string;
    recordVersion: string;
    quoteType: QuoteType;
    unitType: UnitTypeOption;
    currencyTypeOption: CurrencyTypeOption;
    allowNonTaxableItems: boolean;
}

export interface GlobalSupplierApiServerToServerCredentials {
    host: string;
    serverToServerToken: string;
    tenantId: number;
    globalSupplierId: number;
}

export interface InputAddBranchInboxItem {
    branchId: string;
    subject: string;
    message: string;
    attachments: BranchInboxAttachments;
    navigation: BranchInboxNavigation;
}

export interface InputAddBranchQuoteSupport {
    id: string;
    conversationId: string | null;
    subject: string;
    branchQuoteId: string;
    status: BranchQuoteSupportStatus;
    type: BranchQuoteSupportItemType;
    conversationEntry: InputFirstConversationEntry | null;
    masterDocumentConversationEntry: InputFirstConversationEntry | null;
}

export interface InputAddConversationEntry {
    conversationEntryId: string;
    draft: boolean;
    conversationId: string;
    text: string;
    attachments: AddConversationAttachment[];
    users: string[];
    branchQuoteSupportId: string | null;
}

export interface InputBoundConversationEntry {
    id: string;
    text: string;
    attachments: AddConversationAttachment[];
    users: string[];
}

export interface InputCSVProducer {
    data: CSVProducerData[];
    fileName: string;
}

export interface InputCleanupConversationAttachments {
    conversationId: string;
    conversationEntryId: string;
}

export interface InputCreateBranch {
    id: string | null;
    taxRegistrationNumber: string | null;
    name: string;
    abbreviation: string;
    physicalAddress: Address;
    billingAddress: Address | null;
    physicalAddressAsDefaultShipping: boolean;
    shippingNotes: string | null;
}

export interface InputCreateBranchQuote {
    branchQuote: BranchQuote;
}

export interface InputCreateBuyIn {
    tenantId: number;
    buyInStockItems: BuyInStockItem[];
}

export interface InputCreateFranchiseeClient {
    id: string;
    paymentProfileId: string | null;
    externalCustomerReference: string | null;
}

export interface InputCreatePaymentProfile {
    paymentProfile: PaymentProfile;
}

export interface InputCreatePurchaseOrder {
    purchaseOrder: PurchaseOrder;
    lineItems: InputLineItem[];
    numberSeed: string;
}

export interface InputDeleteBranch {
    branchId: string;
    recordVersion: string;
}

export interface InputDeleteBranchQuote {
    branchQuoteId: string;
}

export interface InputDeletePaymentProfile {
    paymentProfileId: string;
    recordVersion: string;
}

export interface InputDuplicateBranchQuoteSupport {
    branchQuoteSupportId: string;
    originalQuoteItemId: string;
    branchQuoteId: string;
    quoteItemId: string;
    quoteItemConversationType: QuoteItemConversationType | null;
    status: BranchQuoteSupportStatus | null;
    conversationEntries: InputBoundConversationEntry[] | null;
}

export interface InputDuplicateConversation {
    conversationId: string;
    newConversationId: string;
    conversationEntries: InputBoundConversationEntry[] | null;
}

export interface InputFirstConversationEntry {
    id: string;
    text: string;
    attachments: AddConversationAttachment[];
    users: string[];
}

export interface InputGetActiveUserInformation {
    systemUserId: string;
}

export interface InputLineItem {
    id: string;
    grossQuantityCost: number;
    grossSupplierQuantityCost: number;
    supplierPriceAdjustment: number;
}

export interface InputLockResource {
    sessionLock: string;
    resourceId: string;
    resourceType: string | null;
}

export interface InputLockResources {
    locks: InputLockResource[];
}

export interface InputQueueCleanupConversationAttachments {
    conversationId: string;
    conversationEntryId: string;
}

export interface InputQuoteItemConversation {
    quoteId: string;
    quoteItemId: string;
    type: QuoteItemConversationType;
    conversationId: string | null;
}

export interface InputQuoteItemConversations {
    quoteItemIds: string[];
}

export interface InputResolveBranchQuoteSupport {
    quoteSetId: string;
    resolutionReason: string;
}

export interface InputUnLockResource {
    sessionLock: string;
    resourceId: string;
}

export interface InputUnLockResources {
    locks: InputUnLockResource[];
}

export interface InputUpdateBranch {
    branch: Branch;
}

export interface InputUpdateBranchQuote {
    branchQuote: BranchQuote;
}

export interface InputUpdateBranchQuoteSupport {
    branchQuoteSupportId: string;
    masterDocumentConversationId: string | null;
    branchQuoteId: string | null;
    subject: string | null;
    quoteItemIdToDetach: string | null;
    status: BranchQuoteSupportStatus | null;
    conversationEntries: InputBoundConversationEntry[] | null;
}

export interface InputUpdateClientPrimaryProfile {
    clientId: string;
    primaryProfileId: string | null;
    rowVersion: string | null;
}

export interface InputUpdateConversationEntry {
    draft: boolean;
    deleteEntry: boolean;
    conversationId: string;
    conversationEntryId: string;
    text: string;
    attachments: AddConversationAttachment[];
    users: string[];
    forceUpdate: boolean;
}

export interface InputUpdateFranchisee {
    franchisee: Franchisee | null;
}

export interface InputUpdateFranchiseeConfiguration {
    franchiseeConfiguration: FranchiseeConfiguration;
    taxRates: TaxRate[];
}

export interface InputUpdateFranchiseeProperties {
    properties: { [key: string]: string; };
}

export interface InputUpdatePaymentProfile {
    paymentProfile: PaymentProfile;
}

export interface InputUpdatePurchaseOrder {
    purchaseOrder: PurchaseOrder;
    stateChangeReason: InputUpdatePurchaseOrderStateChangeReason | null;
}

export interface InputUpdatePurchaseOrderStateChangeReason {
    stateChangeReason: PurchaseOrderStateChangeReason;
    comment: string;
}

export interface InputUpdateStock {
    stock: StockItem[];
}

export interface LookupStockItem {
    supplierId: string;
    code: string;
    libCode: string;
    supplierCode: string;
}

export interface PaymentProfile {
    dateCreated: string;
    id: string;
    recordVersion: string;
    franchiseeId: string;
    branchId: string;
    name: string;
    value: number;
    discount: number | null;
    quoteTerms: string | null;
    estimateTerms: string | null;
    supplierId: string;
    calculation: PaymentProfileCalculation;
}

export enum PaymentProfileCalculation {
    Margin = 1,
    Markup = 2,
}

export interface PaymentProfileSummary {
    id: string;
    name: string;
    value: number;
    discount: number | null;
    supplierId: string;
    calculation: PaymentProfileCalculation;
}

export interface PaymentProfileSummaryResultPaginated {
    count: number;
    pageCount: number;
    pageSize: number;
    pageIndex: number;
    results: PaymentProfileSummary[];
}

export interface PricingRule {
    id: string;
    supplierId: number;
    name: string;
    ruleTypeId: string;
    minValue: number;
    maxValue: number;
    minMarkup: number;
    maxMarkup: number;
}

export interface PricingRuleType {
    id: string;
    name: string;
    hasMinMax: boolean;
}

export interface PurchaseOrder {
    dateCreated: string;
    id: string;
    recordVersion: string;
    title: string;
    purchaseOrderNumber: number;
    branchQuoteId: string;
    state: PurchaseOrderState;
    description: string;
    installationDate: string | null;
    creationUserId: string;
    lastModifiedUserId: string;
    lastModifiedDate: string | null;
    assignedToUserId: string;
    reference: string;
    customPurchaseOrderNumber: string | null;
    supplierId: string;
    supplierSystemLastModifiedDate: string | null;
    supplierSystemDeliveryDate: string | null;
    supplierSystemClosedDate: string | null;
    supplierSystemStatus: string | null;
    supplierSystemShippingLeadTime: number | null;
    calculatedNetTotal: number;
    calculatedAdjustmentTotal: number;
}

export interface PurchaseOrderBranchView {
    dateCreated: string;
    id: string;
    recordVersion: string;
    title: string;
    purchaseOrderNumber: number;
    branchQuoteId: string;
    state: PurchaseOrderState;
    description: string;
    installationDate: string | null;
    supplierSystemLastModifiedDate: string | null;
    supplierSystemDeliveryDate: string | null;
    supplierSystemClosedDate: string | null;
    supplierSystemStatus: string | null;
    supplierSystemShippingLeadTime: number | null;
    creationUserId: string;
    lastModifiedUserId: string;
    lastModifiedDate: string | null;
    reference: string;
    customPurchaseOrderNumber: string | null;
    supplierId: string;
    calculatedNetTotal: number;
    calculatedAdjustmentTotal: number;
    branchId: string;
    assignedToUserId: string;
}

export interface PurchaseOrderBranchViewResultPaginated {
    count: number;
    pageCount: number;
    pageSize: number;
    pageIndex: number;
    results: PurchaseOrderBranchView[];
}

export interface PurchaseOrderDTO {
    id: string;
    branchId: string;
    quoteId: string;
    title: string;
    purchaseOrderNumber: number;
    reference: string;
    state: number;
    installationDate: string | null;
    calculatedNettTotal: number;
    supplierSystemClosedDate: string | null;
    supplierSystemDeliveryDate: string | null;
    supplierSystemStatus: string | null;
    calculatedAdjustmentTotal: number;
    recordVersion: string;
    assignedToUserId: string;
    creationUserId: string;
    lastModifiedUserId: string;
}

export interface PurchaseOrderHistoryState {
    state: PurchaseOrderState;
    numberOfDaysHistory: number | null;
}

export interface PurchaseOrderItem {
    dateCreated: string;
    id: string;
    recordVersion: string;
    purchaseOrderId: string;
    quoteItemId: string;
}

export interface PurchaseOrderQuoteInfo {
    purchaseOrderId: string;
    quoteId: string;
}

export interface PurchaseOrderResultPaginated {
    count: number;
    pageCount: number;
    pageSize: number;
    pageIndex: number;
    results: PurchaseOrder[];
}

export enum PurchaseOrderState {
    None = 0,
    Draft = 1,
    Issued = 2,
    Completed = 4,
    Cancelled = 8,
    IssuedPending = 16,
}

export interface PurchaseOrderStateAudit {
    dateCreated: string;
    id: string;
    recordVersion: string;
    state: PurchaseOrderState;
    dateModified: string;
    purchaseOrderId: string;
    systemUserId: string;
    stateChangeReasonId: string | null;
    comment: string | null;
}

export interface PurchaseOrderStateChangeReason {
    dateCreated: string;
    id: string;
    recordVersion: string;
    purchaseOrderStateReasonOwnerId: string;
    category: PurchaseOrderState;
    reason: string;
}

export interface PurchaseOrderStateChangeReasonPresentation {
    dateCreated: string;
    id: string;
    recordVersion: string;
    purchaseOrderStateReasonOwnerId: string;
    category: PurchaseOrderState;
    itemDisplayOrder: string[];
}

export interface PurchaseOrderSupplierInfo {
    purchaseOrderId: string;
    reference: string;
    supplierSystemDeliveryDate: string | null;
    supplierSystemClosedDate: string | null;
    supplierSystemNotesToDealer: string | null;
    supplierSystemStatus: string | null;
    supplierSystemShippingLeadTime: number | null;
}

export interface QuoteItemConversation {
    dateCreated: string;
    id: string;
    recordVersion: string;
    quoteId: string;
    quoteItemId: string;
    conversationId: string;
    type: QuoteItemConversationType;
}

export interface QuoteItemConversationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: QuoteItemConversation | null;
}

export enum QuoteItemConversationType {
    None = 0,
    EngineeredToOrder = 1,
}

export enum QuoteType {
    None = 0,
    Estimate = 1,
    Quote = 2,
    Display = 4,
    Warranty = 8,
}

export interface RequestBrowsePaymentProfileSummary {
    filter: string | null;
    requestPage: RequestPaginated | null;
    supplierId: string | null;
    branchId: string;
    sortField: string | null;
    sortAsc: boolean;
}

export interface RequestConversation {
    maxRecordVersion: string | null;
    conversationId: string;
    sortAscending: boolean;
    startIndex: number;
    count: number;
    fetchAllAttachments: boolean;
    fetchAllUsers: boolean;
}

export interface RequestGetAllLinkedQuoteItemsForConversation {
    conversationId: string;
}

export interface RequestGetBranch {
    franchiseeId: string;
    branchId: string;
}

export interface RequestGetBranchInboxItems {
    branchId: string;
}

export interface RequestGetBranchQuoteSupport {
    quoteSetId: string;
    quoteId: string | null;
    branchQuoteSupportId: string | null;
}

export interface RequestGetBranchQuoteSupportInbox {
    requestPage: RequestPaginated;
    ticketOwnerId: string | null;
    typeFilter: BranchQuoteSupportItemType;
    statusFilter: BranchQuoteSupportStatus;
    filter: string | null;
    sortField: string | null;
    sortAsc: boolean;
    branchId: string;
}

export interface RequestGetBranchQuotes {
    branchQuoteIds: string[];
}

export interface RequestGetBranches {
}

export interface RequestGetClientDefaultPaymentProfileById {
    clientId: string;
}

export interface RequestGetClientDefaultPaymentProfileListByIds {
    paymentProfileIds: string[];
}

export interface RequestGetClientDefaultPaymentType {
    clientId: string;
}

export interface RequestGetDeploymentSuppliers {
    dealerDeploymentId: number;
}

export interface RequestGetFranchisee {
}

export interface RequestGetFranchiseeClientListByIds {
    clientIds: string[];
}

export interface RequestGetFranchiseeConfiguration {
}

export interface RequestGetGeneratedPurchaseOrderRevenue {
    startDate: string;
    endDate: string;
    branchId: string;
    userId: string;
}

export interface RequestGetNewPurchaseOrdersForSupplier {
    tenantId: number;
    supplierId: string;
    deploymentId: number;
    fromRecordVersion: string;
}

export interface RequestGetPaymentProfile {
    paymentProfileId: string;
}

export interface RequestGetPurchaseOrder {
    purchaseOrderId: string;
}

export interface RequestGetPurchaseOrderDeliveryPipeline {
    pageIndex: number;
    pageSize: number;
    cutOffDate: string | null;
    purchaseOrderOwnerId: string | null;
    assignedToUserId: string | null;
}

export interface RequestGetPurchaseOrderStateAudit {
    purchaseOrderId: string;
    state: PurchaseOrderState | null;
}

export interface RequestGetPurchaseOrderStateChangeReasonsByOwnerIds {
    purchaseOrderStateReasonsOwnerIds: string[];
}

export interface RequestGetPurchaseOrderTotalsByState {
    ownerId: string;
    options: PurchaseOrderHistoryState[];
}

export interface RequestGetPurchaseOrderUserIdsByBranchId {
    branchId: string;
}

export interface RequestGetPurchaseOrderUserIdsByBranchIds {
    branchIds: string[];
}

export interface RequestGetPurchaseOrders {
    purchaseOrderOwnerId: string | null;
    statesToLoad: PurchaseOrderState;
    filter: string | null;
    pageSize: number;
    pageIndex: number;
    sortField: string | null;
    sortAsc: boolean;
    createdById: string | null;
    numberOfDaysHistory: number | null;
}

export interface RequestGetPurchaseOrdersById {
    purchaseOrderIds: string[];
}

export interface RequestGetResourceLocks {
    resourceType: string;
}

export interface RequestGetStock {
    filter: string | null;
}

export interface RequestGetSupplierApiAccess {
    supplierId: string;
    deploymentId: number;
}

export interface RequestGetSupplierConfiguration {
    supplierId: string;
}

export interface RequestGetSupplierPricingRule {
    supplierId: string;
}

export interface RequestGetSupplierPurchaseOrderRecipients {
    supplierId: string;
}

export interface RequestGetSupplierQuoteSettings {
    supplierId: string;
}

export interface RequestGetSupplierTAC {
    supplierId: string;
}

export interface RequestGetTenantPurchaseOrdersProcessing {
    tenantId: number;
    supplierId: string;
}

export interface RequestGetTenants {
    dealerDeploymentId: number;
}

export interface RequestLookupStock {
    lookup: LookupStockItem[];
}

export interface RequestPaginated {
    pageSize: number;
    pageIndex: number;
}

export interface RequestSetTenantPurchaseOrdersProcessing {
    tenantId: number;
    items: PurchaseOrderSupplierInfo[];
}

export interface RequestSystemConfiguration {
}

export interface ResourceLock {
    id: string;
    resourceType: string;
    systemUserId: string;
    sessionLock: string;
    optmisticLock: string;
}

export interface ResultAddBranchInboxItem {
    item: BranchInboxItem;
}

export interface ResultAddBranchInboxItemServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultAddBranchInboxItem | null;
}

export interface ResultAddConversationEntry {
    conversationEntry: ViewConversationEntry;
}

export interface ResultAddConversationEntryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultAddConversationEntry | null;
}

export interface ResultBranchQuoteSupport {
    branchQuoteSupport: BranchQuoteSupport;
    masterDocument: ViewConversationEntry | null;
}

export interface ResultBranchQuoteSupportServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultBranchQuoteSupport | null;
}

export interface ResultBrowsePaymentProfileSummary {
    paymentProfileSummary: PaymentProfileSummaryResultPaginated;
}

export interface ResultBrowsePaymentProfileSummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultBrowsePaymentProfileSummary | null;
}

export interface ResultCSVProducer {
    data: string;
}

export interface ResultCSVProducerServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCSVProducer | null;
}

export interface ResultCleanupConversationAttachments {
}

export interface ResultCleanupConversationAttachmentsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCleanupConversationAttachments | null;
}

export interface ResultConversation {
    startIndex: number;
    conversationEntries: ViewConversationEntry[];
    conversationEntryCount: number;
    conversationAttachments: ViewConversationAttachment[];
    conversationUsers: string[];
    maxRecordVersion: string;
}

export interface ResultConversationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultConversation | null;
}

export interface ResultConversationUploadAttachment {
    success: boolean;
    message: string;
    files: ViewConversationAttachment[];
}

export interface ResultConversationUploadAttachmentServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultConversationUploadAttachment | null;
}

export interface ResultCreateBranch {
    branch: Branch;
}

export interface ResultCreateBranchQuote {
    branchQuote: BranchQuote | null;
}

export interface ResultCreateBranchQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateBranchQuote | null;
}

export interface ResultCreateBranchServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateBranch | null;
}

export interface ResultCreateBuyIn {
}

export interface ResultCreateBuyInServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateBuyIn | null;
}

export interface ResultCreateFranchiseeClient {
    franchiseeClient: FranchiseeClient;
}

export interface ResultCreateFranchiseeClientServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateFranchiseeClient | null;
}

export interface ResultCreatePaymentProfile {
    paymentProfile: PaymentProfile | null;
}

export interface ResultCreatePaymentProfileServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreatePaymentProfile | null;
}

export interface ResultCreatePurchaseOrder {
    purchaseOrder: PurchaseOrder;
    purchaseOrderItems: PurchaseOrderItem[];
}

export interface ResultCreatePurchaseOrderServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreatePurchaseOrder | null;
}

export interface ResultDeleteBranch {
}

export interface ResultDeleteBranchQuote {
}

export interface ResultDeleteBranchQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDeleteBranchQuote | null;
}

export interface ResultDeleteBranchServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDeleteBranch | null;
}

export interface ResultDeletePaymentProfile {
}

export interface ResultDeletePaymentProfileServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDeletePaymentProfile | null;
}

export interface ResultDuplicateBranchQuoteSupport {
    branchQuoteSupport: BranchQuoteSupport;
    quoteItemConversation: QuoteItemConversation;
    masterDocument: ViewConversationEntry;
}

export interface ResultDuplicateBranchQuoteSupportServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDuplicateBranchQuoteSupport | null;
}

export interface ResultDuplicateConversation {
}

export interface ResultDuplicateConversationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDuplicateConversation | null;
}

export interface ResultGetActiveUserInformation {
    franchisee: Franchisee;
    franchiseeConfiguration: FranchiseeConfiguration;
    taxRates: TaxRate[];
    branches: Branch[];
    defaultBranchId: string;
    userClaims: { [key: string]: string; };
}

export interface ResultGetActiveUserInformationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetActiveUserInformation | null;
}

export interface ResultGetAllLinkedQuoteItemsForConversation {
    quoteItemIds: string[];
}

export interface ResultGetAllLinkedQuoteItemsForConversationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetAllLinkedQuoteItemsForConversation | null;
}

export interface ResultGetBranch {
    branch: Branch | null;
}

export interface ResultGetBranchInboxItems {
    items: ViewBranchInboxItem[];
}

export interface ResultGetBranchInboxItemsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetBranchInboxItems | null;
}

export interface ResultGetBranchQuoteSupport {
    items: BranchQuoteSupport[];
    masterDocuments: ViewConversationEntry[];
    conversationLinks: QuoteItemConversation[];
}

export interface ResultGetBranchQuoteSupportInbox {
    items: ViewBranchQuoteSupportInboxItemResultPaginated;
    conversationLinks: QuoteItemConversation[];
}

export interface ResultGetBranchQuoteSupportInboxServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetBranchQuoteSupportInbox | null;
}

export interface ResultGetBranchQuoteSupportServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetBranchQuoteSupport | null;
}

export interface ResultGetBranchQuotes {
    branchQuotes: BranchQuote[];
}

export interface ResultGetBranchQuotesServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetBranchQuotes | null;
}

export interface ResultGetBranchServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetBranch | null;
}

export interface ResultGetBranches {
    branches: Branch[];
    branchUsers: { [key: string]: ViewBranchUser[]; };
}

export interface ResultGetBranchesServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetBranches | null;
}

export interface ResultGetClientDefaultPaymentProfileById {
    profile: ViewClientDefaultPaymentProfile;
}

export interface ResultGetClientDefaultPaymentProfileByIdServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetClientDefaultPaymentProfileById | null;
}

export interface ResultGetClientDefaultPaymentProfileListByIds {
    profiles: PaymentProfile[];
}

export interface ResultGetClientDefaultPaymentProfileListByIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetClientDefaultPaymentProfileListByIds | null;
}

export interface ResultGetClientDefaultPaymentType {
    paymentProfileSummary: ViewClientDefaultPaymentProfile | null;
}

export interface ResultGetClientDefaultPaymentTypeServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetClientDefaultPaymentType | null;
}

export interface ResultGetDeploymentSuppliers {
    items: SupplierData[];
}

export interface ResultGetDeploymentSuppliersServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetDeploymentSuppliers | null;
}

export interface ResultGetFranchisee {
    franchisee: Franchisee;
}

export interface ResultGetFranchiseeClientListByIds {
    clients: FranchiseeClient[];
}

export interface ResultGetFranchiseeClientListByIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetFranchiseeClientListByIds | null;
}

export interface ResultGetFranchiseeConfiguration {
    franchiseeConfiguration: FranchiseeConfiguration;
    taxRates: TaxRate[];
}

export interface ResultGetFranchiseeConfigurationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetFranchiseeConfiguration | null;
}

export interface ResultGetFranchiseeServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetFranchisee | null;
}

export interface ResultGetGeneratedPurchaseOrderRevenue {
    revenueSummary: ViewDailyRevenue[];
    startDate: string;
    endDate: string;
}

export interface ResultGetGeneratedPurchaseOrderRevenueServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetGeneratedPurchaseOrderRevenue | null;
}

export interface ResultGetNewPurchaseOrdersForSupplier {
    purchaseOrders: PurchaseOrderDTO[];
}

export interface ResultGetNewPurchaseOrdersForSupplierServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetNewPurchaseOrdersForSupplier | null;
}

export interface ResultGetPaymentProfile {
    paymentProfile: PaymentProfile | null;
}

export interface ResultGetPaymentProfileServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPaymentProfile | null;
}

export interface ResultGetPurchaseOrder {
    purchaseOrder: PurchaseOrderBranchView;
    purchaseOrderItems: PurchaseOrderItem[];
}

export interface ResultGetPurchaseOrderDeliveryPipeline {
    purchaseOrdersBranchView: PurchaseOrderBranchViewResultPaginated;
}

export interface ResultGetPurchaseOrderDeliveryPipelineServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrderDeliveryPipeline | null;
}

export interface ResultGetPurchaseOrderServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrder | null;
}

export interface ResultGetPurchaseOrderStateAudit {
    purchaseOrderStateAudit: PurchaseOrderStateAudit[];
}

export interface ResultGetPurchaseOrderStateAuditServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrderStateAudit | null;
}

export interface ResultGetPurchaseOrderStateChangeReasonsByOwnerIds {
    purchaseOrderReasons: ResultPurchaseOrderStateChangeReasonsForOwnerId[];
}

export interface ResultGetPurchaseOrderStateChangeReasonsByOwnerIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrderStateChangeReasonsByOwnerIds | null;
}

export interface ResultGetPurchaseOrderTotalsByState {
    totals: ViewPurchaseOrderTotalByState[];
}

export interface ResultGetPurchaseOrderTotalsByStateServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrderTotalsByState | null;
}

export interface ResultGetPurchaseOrderUserIdsByBranchId {
    userIds: string[];
}

export interface ResultGetPurchaseOrderUserIdsByBranchIdServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrderUserIdsByBranchId | null;
}

export interface ResultGetPurchaseOrderUserIdsByBranchIdV1 {
    branchId: string;
    userIds: string[];
}

export interface ResultGetPurchaseOrderUserIdsByBranchIds {
    values: ResultGetPurchaseOrderUserIdsByBranchIdV1[];
}

export interface ResultGetPurchaseOrderUserIdsByBranchIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrderUserIdsByBranchIds | null;
}

export interface ResultGetPurchaseOrders {
    purchaseOrders: PurchaseOrderResultPaginated;
}

export interface ResultGetPurchaseOrdersById {
    purchaseOrders: PurchaseOrderBranchView[];
}

export interface ResultGetPurchaseOrdersByIdServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrdersById | null;
}

export interface ResultGetPurchaseOrdersServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetPurchaseOrders | null;
}

export interface ResultGetResourceLocks {
    items: ResourceLock[];
}

export interface ResultGetResourceLocksServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetResourceLocks | null;
}

export interface ResultGetStock {
    stockItems: StockItem[];
}

export interface ResultGetStockServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetStock | null;
}

export interface ResultGetSupplierApiAccess {
    supplierHosts: GlobalSupplierApiServerToServerCredentials[];
}

export interface ResultGetSupplierApiAccessServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetSupplierApiAccess | null;
}

export interface ResultGetSupplierConfiguration {
    supplierId: string;
    globalSupplierId: number;
    validityPeriod: number;
    leadPeriod: number;
    allowCustomItemRequest: boolean;
    allowSupportRequest: boolean;
    allowSupplierReview: boolean;
    availableQuoteTypes: QuoteType[];
    purchaseOrderTermsAndConditions: string;
    termsAndConditionsOfUse: string;
    watermark: WatermarkType;
    willCallLocations: WillCallLocation[] | null;
    quoteItemSummaryConfigurations: SupplierTableConfig[] | null;
    configLastModifiedUtc: string | null;
}

export interface ResultGetSupplierConfigurationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetSupplierConfiguration | null;
}

export interface ResultGetSupplierPricingRule {
    pricingRule: PricingRule;
    pricingRuleType: PricingRuleType;
}

export interface ResultGetSupplierPricingRuleServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetSupplierPricingRule | null;
}

export interface ResultGetSupplierPurchaseOrderRecipients {
    recpientEmails: string[];
}

export interface ResultGetSupplierPurchaseOrderRecipientsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetSupplierPurchaseOrderRecipients | null;
}

export interface ResultGetSupplierQuoteSettings {
    supplierId: string;
    globalSupplierId: number;
    validityPeriod: number;
    leadPeriod: number;
    allowCustomItemRequest: boolean;
    allowSupportRequest: boolean;
    allowSupplierReview: boolean;
    availableQuoteTypes: QuoteType[];
    watermark: WatermarkType;
    willCallLocations: WillCallLocation[] | null;
    quoteItemSummaryConfigurations: SupplierTableConfig[] | null;
}

export interface ResultGetSupplierQuoteSettingsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetSupplierQuoteSettings | null;
}

export interface ResultGetSupplierTAC {
    supplierPurchaseOrderTermsAndConditions: string;
    supplierTermsAndConditionsOfUse: string;
}

export interface ResultGetSupplierTACServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetSupplierTAC | null;
}

export interface ResultGetTenantPurchaseOrdersProcessing {
    tenantId: number;
    supplierId: string;
    info: PurchaseOrderQuoteInfo[];
}

export interface ResultGetTenantPurchaseOrdersProcessingServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetTenantPurchaseOrdersProcessing | null;
}

export interface ResultGetTenants {
    tenants: TenantData[];
}

export interface ResultGetTenantsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetTenants | null;
}

export interface ResultLockResource {
    lock: ResourceLock;
}

export interface ResultLockResourceServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultLockResource | null;
}

export interface ResultLockResources {
    locks: ResourceLock[];
}

export interface ResultLockResourcesServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultLockResources | null;
}

export interface ResultLookupStock {
    stockItems: StockLookupView[];
}

export interface ResultLookupStockServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultLookupStock | null;
}

export interface ResultPurchaseOrderStateChangeReasonsForOwnerId {
    purchaseOrderStateReasonOwnerId: string;
    purchaseOrderReasons: ResultPurchaseOrderStateChangeReasonsForState[];
}

export interface ResultPurchaseOrderStateChangeReasonsForState {
    category: PurchaseOrderState;
    presentation: PurchaseOrderStateChangeReasonPresentation;
    stateChangeReasons: PurchaseOrderStateChangeReason[];
}

export interface ResultQueueCleanupConversationAttachments {
}

export interface ResultQueueCleanupConversationAttachmentsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultQueueCleanupConversationAttachments | null;
}

export interface ResultQuoteItemConversations {
    items: QuoteItemConversation[];
}

export interface ResultQuoteItemConversationsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultQuoteItemConversations | null;
}

export interface ResultResolveBranchQuoteSupport {
}

export interface ResultResolveBranchQuoteSupportServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultResolveBranchQuoteSupport | null;
}

export interface ResultSetTenantPurchaseOrdersProcessing {
}

export interface ResultSetTenantPurchaseOrdersProcessingServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultSetTenantPurchaseOrdersProcessing | null;
}

export interface ResultSystemConfiguration {
    defaultDealerConfiguration: SystemConfiguration;
}

export interface ResultSystemConfigurationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultSystemConfiguration | null;
}

export interface ResultUnLockResource {
    lock: ResourceLock;
}

export interface ResultUnLockResourceServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUnLockResource | null;
}

export interface ResultUnLockResources {
    locks: ResourceLock[];
}

export interface ResultUnLockResourcesServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUnLockResources | null;
}

export interface ResultUpdateBranch {
    branch: Branch | null;
}

export interface ResultUpdateBranchQuote {
    branchQuote: BranchQuote | null;
}

export interface ResultUpdateBranchQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateBranchQuote | null;
}

export interface ResultUpdateBranchServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateBranch | null;
}

export interface ResultUpdateConversationEntry {
    conversationEntry: ViewConversationEntry | null;
}

export interface ResultUpdateConversationEntryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateConversationEntry | null;
}

export interface ResultUpdateFranchisee {
    franchisee: Franchisee;
}

export interface ResultUpdateFranchiseeClient {
    franchiseeClient: FranchiseeClient | null;
}

export interface ResultUpdateFranchiseeClientServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateFranchiseeClient | null;
}

export interface ResultUpdateFranchiseeConfiguration {
    franchiseeConfiguration: FranchiseeConfiguration;
    taxRates: TaxRate[];
}

export interface ResultUpdateFranchiseeConfigurationServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateFranchiseeConfiguration | null;
}

export interface ResultUpdateFranchiseeProperties {
    properties: { [key: string]: string; };
}

export interface ResultUpdateFranchiseePropertiesServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateFranchiseeProperties | null;
}

export interface ResultUpdateFranchiseeServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateFranchisee | null;
}

export interface ResultUpdatePaymentProfile {
    paymentProfile: PaymentProfile | null;
}

export interface ResultUpdatePaymentProfileServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdatePaymentProfile | null;
}

export interface ResultUpdatePurchaseOrder {
    purchaseOrder: PurchaseOrder;
    purchaseOrderItems: PurchaseOrderItem[];
}

export interface ResultUpdatePurchaseOrderServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdatePurchaseOrder | null;
}

export interface ResultUpdateStock {
    stockItems: StockItem[];
}

export interface ResultUpdateStockServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateStock | null;
}

export interface ResultVerifyUser {
    claims: { [key: string]: string; };
}

export interface ServiceResponseError {
    message: string;
    stackTrace: string | null;
}

export enum ServiceResponseType {
    None = 0,
    Ok = 1,
    NotFound = 2,
    UnAuthenticated = 4,
    UnAuthorized = 8,
    Error = 16,
    TransientDbError = 32,
    ValidationFailure = 64,
    ModifyNotFound = 128,
}

export interface StockItem {
    dateCreated: string;
    id: string;
    recordVersion: string;
    code: string;
    description: string;
    singleUnitCost: number | null;
    itemContentType: number;
    stockCategoryId: string;
}

export interface StockLookupView {
    code: string;
    supplierId: string;
    libCode: string;
    supplierCode: string;
    cost: number | null;
    description: string;
    version: string;
}

export interface SupplierData {
    id: number;
    name: string;
    supplierId: string;
}

export interface SupplierTableConfig {
    code: string;
    title: string;
    systemDefault: boolean;
    defaultDisplay: boolean;
    canSwitch: boolean;
}

export interface SystemConfiguration {
    quoteItemColumnConfigurations: TableColumnConfiguration[];
}

export interface TableColumnConfiguration {
    code: string;
    title: string;
    systemDefault: boolean;
    defaultDisplay: boolean;
    canSwitch: boolean;
}

export interface TaxRate {
    dateCreated: string;
    id: string;
    recordVersion: string;
    franchiseeId: string;
    name: string;
    rate: number;
    position: number;
    dateModified: string;
    modifiedUserId: string;
}

export interface TenantData {
    id: number;
    name: string;
    suppliers: string[];
}

export interface UINavigation {
    id: string;
    itemType: string;
}

export enum UnitTypeOption {
    Metric = 1,
    Imperial = 2,
}

export interface ViewBranchInboxItem {
    dateCreated: string;
    id: string;
    recordVersion: string;
    subject: string;
    branchId: string;
    message: string;
    attachments: BranchInboxAttachments;
    navigation: BranchInboxNavigation;
    state: BranchInboxItemState;
}

export interface ViewBranchQuoteSupportInboxItem {
    subject: string;
    branchQuoteId: string;
    requestType: BranchQuoteSupportItemType;
    status: BranchQuoteSupportStatus;
    createdUserId: string;
    dateCreated: string;
    lastModifiedUserId: string;
    lastModified: string;
    conversationId: string;
    quoteTitle: string;
    quoteNumber: number;
    quoteSuffix: string;
    quoteType: number;
    clientName: string;
}

export interface ViewBranchQuoteSupportInboxItemResultPaginated {
    count: number;
    pageCount: number;
    pageSize: number;
    pageIndex: number;
    results: ViewBranchQuoteSupportInboxItem[];
}

export interface ViewBranchUser {
    userId: string;
    isActive: boolean;
}

export interface ViewClientDefaultPaymentProfile {
    clientId: string;
    profileId: string;
    name: string;
}

export interface ViewConversationAttachment {
    filename: string;
    virtualPath: string;
    publicUrl: string;
    size: number;
    embedded: boolean;
}

export interface ViewConversationEntry {
    id: string;
    franchiseeId: string;
    conversationId: string;
    dateCreated: string;
    lastModified: string;
    editCount: number;
    systemUserId: string;
    text: string;
    attachments: ViewConversationAttachment[];
    users: string[];
    draft: boolean;
}

export interface ViewDailyRevenue {
    count: number;
    date: string;
    dailyRevenue: number;
}

export interface ViewPurchaseOrderTotalByState {
    ownerId: string;
    state: PurchaseOrderState;
    userId: string;
    total: number;
    count: number;
}

export enum WatermarkType {
    DraftInternalRed = 0,
    DraftInternal = 1,
    InternalUse = 2,
    Draft = 4,
    DraftVersion = 8,
}

export interface WillCallAddress {
    line1: string;
    line2: string | null;
    line3: string | null;
    line4: string | null;
    locality: string | null;
    region: string | null;
    postcode: string;
    country: string | null;
    latitude: string | null;
    longitude: string | null;
    source: string | null;
}

export interface WillCallLocation {
    id: string;
    title: string;
    type: string;
    willCallAddress: WillCallAddress;
}